import * as React from 'react';
import { useEffect, useState } from 'react';
import Page1Subscribe from './Fragments/Page1';
import Page2Doi from './Fragments/Page2';
import Page3Success from './Fragments/Page3';
import Page4KnownUser from './Fragments/Page4';
import IntlProvider from './IntlProvider';
var NewsletterSubscribe = function (_a) {
    var contentData = _a.contentData, _b = _a.companyId, companyId = _b === void 0 ? process.env.FRAGMENT_COMPANYID : _b, _c = _a.preselectedPage, preselectedPage = _c === void 0 ? 1 : _c;
    var _d = contentData.field_area_key, areaKey = _d === void 0 ? '' : _d;
    var _e = useState(preselectedPage), page = _e[0], setPage = _e[1];
    // prevents getting stuck at the last scroll position after the rerender
    useEffect(function () {
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: 'smooth',
        });
    }, [page]);
    return (React.createElement(IntlProvider, { companyId: companyId },
        page === 1 && React.createElement(Page1Subscribe, { setPage: setPage, areaKey: areaKey }),
        page === 2 && React.createElement(Page2Doi, { "data-testid": "nlDoi" }),
        page === 3 && React.createElement(Page3Success, { "data-testid": "nlSuccess" }),
        page === 4 && React.createElement(Page4KnownUser, { "data-testid": "nlKnownUser" })));
};
export default NewsletterSubscribe;
//# sourceMappingURL=index.js.map